<div class="ot-form-control ot-mb-0" [id]="identifier" >
  <div class="ot-checkbox-group">
    @for (file of getDownloadFileList; track file) {
      <div class="ot-checkbox-options">
        <app-checkbox [identifier]="file.binaryuid" [(ngModel)]="file.selected" (ngModelChange)="onDownloadFileSelect()"
          i18n-label [label]="file.name" i18n-arialabel [arialabel]="file.name">
        </app-checkbox>
      </div>
    }
  </div>
  @if (getDownloadFileList.length == 0) {
    <div>
      <p i18n>There are no items to display.</p>
    </div>
  }
</div>